export default (inputValue, patternString) => {
  if (!patternString) return true;

  const validationPattern = new RegExp(patternString);

  return inputValue.match(validationPattern);
};
